export type DocDue = 'never' | 'immediate' | 'after_days'

export function ruleApplies(
  due: DocDue | string | undefined | null,
  days: number | null | undefined,
  durationDays: number,
): boolean {
  if (due === 'never' || !due) return false
  if (due === 'immediate') return true
  if (due === 'after_days') {
    const n = Number(days)
    if (!Number.isFinite(n) || n < 1) return false
    return durationDays >= n
  }
  return false
}

export function documentWorkOpen(
  due: boolean,
  requestedAt: string | null | undefined,
  hasFile: boolean,
): boolean {
  return (due || Boolean(requestedAt)) && !hasFile
}

const DOC_HARD_CLOSED = ['cancelled', 'expired', 'failed', 'declined']
const DOC_TERMINAL = ['accepted', 'booked', ...DOC_HARD_CLOSED]

export function requestDocumentUi(
  directorOn: boolean,
  request: {
    status: string
    document_due?: boolean
    documents_requested_at?: string | null
    has_document?: boolean
    documents_received?: boolean
  } | null | undefined,
) {
  const hidden = { show: false, outstanding: false, canUpload: false, canDelete: false }
  if (!directorOn || !request) return hidden
  const hasDoc = !!(request.has_document ?? request.documents_received)
  const outstanding = directorOn && documentWorkOpen(
    Boolean(request.document_due),
    request.documents_requested_at,
    hasDoc,
  )
  const docFlagsOn = !!(request.documents_requested_at || hasDoc || request.document_due)
  const gateStatus = request.status === 'director_pending' || request.status === 'director_returned'
  const hardClosed = DOC_HARD_CLOSED.includes(request.status)
  return {
    show: !hardClosed && (docFlagsOn || gateStatus),
    outstanding,
    canUpload: !hardClosed && (!DOC_TERMINAL.includes(request.status) || outstanding),
    canDelete: !DOC_TERMINAL.includes(request.status),
  }
}
